// Consumer-pool roles — distinct from the internal admin-pool roles in
// `roles.ts`. Two separate role systems on purpose:
//
//   - Internal roles (super_admin, content_editor, customer_success,
//     analyst, read_only) live in `roles.ts` and apply to the
//     internal_admin Cognito pool (GC Coach staff). They gate the
//     admin SPA at admin.gc-coach.ai.
//
//   - Consumer roles (tenant_admin, ...) live HERE and apply to the
//     consumer Cognito pool (tenant users). They gate the future
//     tenant-admin portal SPA at {tenant-slug}.gc-coach.ai.
//
// The two enums never mix. A user in the internal pool can't have a
// consumer role; a user in the consumer pool can't have an internal
// role. JWT verification looks at `iss` (issuer) to know which pool
// issued the token and validates the role belongs to that pool.
//
// V1: only `tenant_admin` exists. Phase 1 will add roles like
// `tenant_user`, `tenant_billing_contact`, etc. as the consumer
// product surface grows.

/** Closed enum of consumer-pool roles. */
export type ConsumerRoleKey = 'tenant_admin';

export const ALL_CONSUMER_ROLES: ReadonlyArray<ConsumerRoleKey> = [
  'tenant_admin',
] as const;

/** Type guard for the closed consumer-role enum. */
export function isConsumerRoleKey(value: unknown): value is ConsumerRoleKey {
  return typeof value === 'string' && (ALL_CONSUMER_ROLES as ReadonlyArray<string>).includes(value);
}
